/**
 * Property names rejected for prototype-pollution safety (§11 Security Model).
 * Shared by write-side context builders (`buildFlowContext`) and read-side
 * path walks (`getByPath`) so the deny-list cannot drift.
 */
export const FORBIDDEN_KEYS = new Set([
  '__proto__',
  'constructor',
  'prototype',
]);
